export const FAVOURITE_TARGETS = Object.freeze({
  supplier: "SAPPHIRE_SUPPLIER",
  product: "SAPPHIRE_PRODUCT",
});

export const ALL_PAGE_SIZE = -1;

const numberOr = (value, fallback) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
};

export const mapFavourite = (dto) => ({
  id: dto.id,
  targetId: dto.targetId,
  targetType: dto.targetType,
  savedAt: dto.savedAt || null,
});

export const normalizeFavouritesPage = (dto) => {
  const items = (dto?.data || [])
    .filter((row) => row && row.targetId !== null && row.targetId !== undefined)
    .filter((row) => row.saved !== false)
    .map(mapFavourite);

  const page = numberOr(dto?.currentPage, 1);
  const totalPages = numberOr(dto?.totalPages, items.length ? 1 : 0);

  return {
    items,
    total: numberOr(dto?.totalElements, items.length),
    page,
    totalPages,
    isLast: page >= totalPages,
  };
};

const indexOfTarget = (page, targetId) =>
  page.items.findIndex((item) => item.targetId === targetId);

export const withoutTarget = (page, targetId) => {
  const index = indexOfTarget(page, targetId);
  if (index < 0) return page;

  return {
    ...page,
    items: page.items.filter((item, position) => position !== index),
    total: Math.max(0, page.total - 1),
  };
};

export const withTarget = (page, { targetId, targetType }, position = 0) => {
  if (indexOfTarget(page, targetId) >= 0) return page;

  const items = [...page.items];
  items.splice(Math.min(Math.max(position, 0), items.length), 0, {
    id: -targetId,
    targetId,
    targetType,
    savedAt: null,
  });

  return { ...page, items, total: page.total + 1 };
};
